// frontend/admin-portal/src/components/sales/InvoiceStats.jsx
import React, { useEffect, useState } from "react";
import { Card } from "@fiberhome/shared-ui";
import { invoiceService } from "../../services/invoiceService";

export default function InvoiceStats({ refreshKey }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    invoiceService.stats()
      .then((d) => { if (!cancelled) setStats(d); })
      .catch(() => { if (!cancelled) setStats(null); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [refreshKey]);

  return (
    <div className="fh-dash-kpis" style={{ marginBottom: "1.25rem" }}>
      <Card label="Total" value={stats?.total} loading={loading} icon="🧾" tone="primary" />
      <Card label="Draft" value={stats?.draft} loading={loading} icon="✏️" tone="default" />
      <Card label="Issued" value={stats?.issued} loading={loading} icon="📤" tone="info" />
      <Card label="Paid" value={stats?.paid} loading={loading} icon="✅" tone="success" />
      <Card label="Overdue" value={stats?.overdue} loading={loading} icon="⚠️" tone="danger" />
    </div>
  );
}